module.exports = __webpack_public_path__ + "img/dropdown-blob-lightgrey.0516baa4.svg";